
((Drupal, once) => {

  function makeSlider({ track, prevBtn, nextBtn, dotBtns, thumbBtns, captionEls, onSlide, loop = false }) {
    let current = 0;
    const total = track.children.length;

    function goTo(index, animate = true) {
      if (total === 0) return;
      current = ((index % total) + total) % total;
      track.style.transition = animate ? '' : 'none';
      track.style.transform  = `translateX(-${current * 100}%)`;

      // Dots
      dotBtns && dotBtns.forEach((d, i) => {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });

      // Thumbnails
      thumbBtns && thumbBtns.forEach((t, i) => {
        t.classList.toggle('is-active', i === current);
        if (i === current) t.scrollIntoView({ inline: 'nearest', behavior: 'smooth' });
      });

      // Captions (lightbox) — use inline style to guarantee hide/show
      // regardless of any theme CSS overriding .is-hidden
      captionEls && captionEls.forEach((c, i) => {
        if (i === current) {
          c.style.removeProperty('display');
          c.classList.remove('is-hidden');
        } else {
          c.style.display = 'none';
          c.classList.add('is-hidden');
        }
      });

      // Arrows — hide completely at boundaries (non-looping)
      if (!loop) {
        if (prevBtn) prevBtn.style.display = current === 0           ? 'none' : '';
        if (nextBtn) nextBtn.style.display = current === total - 1   ? 'none' : '';
      }

      onSlide && onSlide(current, total);
    }

    function handleArrow(e, delta) {
      e.preventDefault();
      e.stopPropagation();
      goTo(current + delta);
    }

    prevBtn && prevBtn.addEventListener('click', e => handleArrow(e, -1));
    nextBtn && nextBtn.addEventListener('click', e => handleArrow(e, 1));

    dotBtns && dotBtns.forEach((d, i) => {
      d.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); goTo(i); });
    });

    thumbBtns && thumbBtns.forEach((t, i) => {
      t.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); goTo(i); });
    });

    // Swipe
    let startX = null;
    track.addEventListener('pointerdown', e => { startX = e.clientX; });
    track.addEventListener('pointerup', e => {
      if (startX === null) return;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
      startX = null;
    });

    // Keyboard
    track.parentElement.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    goTo(0, false);
    return { goTo, getIndex: () => current };
  }

  Drupal.behaviors.gallerySlider = {
    attach(context) {
      for (const el of once('gallery-slider', '.gallery-slider', context)) {
        const galleryId = el.id;
        const lightbox  = document.getElementById(`${galleryId}-lightbox`);

        // ── Main slider ────────────────────────────
        const mainTrack = el.querySelector('.gallery-slider__track');
        const mainPrev  = el.querySelector('.gallery-slider__arrow--prev');
        const mainNext  = el.querySelector('.gallery-slider__arrow--next');
        const dotBtns   = [...el.querySelectorAll('.gallery-slider__dot')];
        const captions  = [...el.querySelectorAll('.gallery-slider__caption')];
        // Force-hide all captions via inline style on init
        captions.forEach((c, i) => { if (i !== 0) c.style.display = 'none'; });

        const mainSlider = makeSlider({
          track:   mainTrack,
          prevBtn: mainPrev,
          nextBtn: mainNext,
          dotBtns,
          loop:    false,
          onSlide(index) {
            captions.forEach((c, i) => {
              if (i === index) {
                c.style.removeProperty('display');
                c.classList.remove('is-hidden');
              } else {
                c.style.display = 'none';
                c.classList.add('is-hidden');
              }
            });
          },
        });

        // ── Lightbox ───────────────────────────────
        if (lightbox) {
          const lbTrack    = lightbox.querySelector('.gallery-lightbox__track');
          const lbPrev     = lightbox.querySelector('.gallery-lightbox__arrow--prev');
          const lbNext     = lightbox.querySelector('.gallery-lightbox__arrow--next');
          const lbThumbs   = [...lightbox.querySelectorAll('.gallery-lightbox__thumb')];
          const lbCaptions = [...lightbox.querySelectorAll('.gallery-lightbox__figcaption')];
          // Force-hide all captions via inline style on init (beats any theme CSS)
          lbCaptions.forEach((c, i) => { if (i !== 0) c.style.display = 'none'; });
          const lbCounter  = lightbox.querySelector('.gallery-lightbox__counter');
          const lbClose    = lightbox.querySelector('.gallery-lightbox__close');
          const lbBackdrop = lightbox.querySelector('.gallery-lightbox__backdrop');

          const lbSlider = makeSlider({
            track:      lbTrack,
            prevBtn:    lbPrev,
            nextBtn:    lbNext,
            thumbBtns:  lbThumbs,
            captionEls: lbCaptions,
            loop:       true,
            onSlide(index, total) {
              if (lbCounter) lbCounter.textContent = `${index + 1} / ${total}`;
            },
          });

          function openLightbox(index) {
            lightbox.removeAttribute('hidden');
            document.body.classList.add('gallery-lightbox-open');
            lbSlider.goTo(index, false);
            lbClose && lbClose.focus();
          }

          function closeLightbox() {
            lightbox.setAttribute('hidden', '');
            document.body.classList.remove('gallery-lightbox-open');
          }

          el.querySelectorAll('[data-lightbox-trigger]').forEach(btn => {
            btn.addEventListener('click', e => {
              e.preventDefault();
              e.stopPropagation();
              openLightbox(mainSlider.getIndex());
            });
          });

          lbClose && lbClose.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            closeLightbox();
          });

          lbBackdrop && lbBackdrop.addEventListener('click', closeLightbox);

          document.addEventListener('keydown', e => {
            if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
          });
        }
      }
    },
  };

})(Drupal, once);
